import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Formik } from 'formik';
import { BEmail, BForm, BPassword, BSubmit } from 'mui-bueno';
import { LoadingProps, LoginRequest } from '../../@types';
import { loginUser } from '../../axios/login';
import { loginSuccess } from '../../modules/login-reducer';
import axiosInstance from '../../axios/axios-instance';
import { useFormStyles, useOtherStyles } from '../../App';
import About from '../About/About';
import Box from '@material-ui/core/Box';
import theme from '../../theme';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Divider from '@material-ui/core/Divider';
import IsLoadingHOC from '../../IsLoadingHOC';
import { Button } from '@material-ui/core';

const useStyles = makeStyles({
	root: {
		maxWidth: '100%',
		margin: '0 auto',
	},
	loginButton: {
		textAlign: 'center',
		margin: '15px auto 20px',
		backgroundColor: theme.palette.secondary.dark,
	},
});

export const Login = (props: LoadingProps) => {
	const globalClasses = useOtherStyles();
	const formClasses = useFormStyles();
	const history = useHistory();
	const dispatcher = useDispatch();
	const classes = useStyles();

	const initialValues: LoginRequest = {
		email: '',
		password: '',
	};

	const handleSignupReroute = () => {
		history.push("/SignUp")
	}

	const handleSubmit = (loginRequest: LoginRequest) => {
		props.setLoading(true)
		loginUser(loginRequest)
			.then((res: any) => {
				axiosInstance.defaults.headers.common.Authorization =
				'Bearer ' + res.data.token;
				dispatcher(loginSuccess(res.data));
				localStorage.setItem('token', res.data.token);
				localStorage.setItem('id', res.data.id)
				localStorage.setItem('firstName', res.data.firstName)
				props.setLoading(false)
				history.push('/Dashboard');
			})
			.catch((err: any) => {
				alert("Incorrect username or password");
				props.setLoading(false)
				console.log('ERROR: ', err);
			});
	};
	
	return (
		<Box className={classes.root}>
			<About />
			<Box
				boxShadow={5}
				bgcolor={theme.palette.primary.light}
				className={formClasses.formWrapper}
			>
				<Typography variant='h4' className={formClasses.formTitle}>
					Login
				</Typography>
				<Typography
					variant='subtitle2'
					className={formClasses.formSubtitle}
				>
					Sign in to your COSINT account.
				</Typography>
				<Divider />
				<Formik
					initialValues={initialValues}
					onSubmit={handleSubmit}
					validateOnChange={false}
					validateOnBlur={false}
				>
					<BForm>
						<BEmail
							required
							full
							name='email'
							placeholder='Email'
						/>
						<BPassword
							required
							full
							name='password'
							placeholder='Password'
							textFieldProps={{
								color: 'primary',
							}}
						/>
						<BSubmit className={classes.loginButton} name='submit'>
							Login
						</BSubmit>
					</BForm>
				</Formik>
				<Box padding='10px 0px 10px 40px'>
					<Typography
						className={formClasses.formSwitchMessage}
						variant='subtitle2'
					>
						Don't have an account?
					</Typography>
					<Link
						onClick={handleSignupReroute}
						className={formClasses.formSwitchLink}
						variant='subtitle2'
					>
						<u>Sign Up</u>
					</Link>
				</Box>
			</Box>
		</Box>
	);
};

export default IsLoadingHOC(Login);
